// Store 状态管理
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    // 01.登录用户权限组
    userPermissions: JSON.parse(localStorage.getItem("userPermissions")) || [],
    // 02.侧边栏伸缩状态
    sideCollapse: JSON.parse(localStorage.getItem("sideCollapse")) || false,
    // 03.页面Tabs数组
    pageOptions: JSON.parse(localStorage.getItem("pageOptions")) || [{'url': '/home', 'name': '工作台'}],
    // 04.Tabs当前选中
    pageActive: JSON.parse(localStorage.getItem("pageActive")) || '/home',
}

export default new Vuex.Store({
    state
})
